/**
 * @generated SignedSource<<2609cc2d5ae4fc4d53253cf530a1fb9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlaylistBlockPlaylistData$data = {
  readonly __typename: "AuthorizedPlaylist";
  readonly canWrite: boolean;
  readonly creator: string;
  readonly description: string | null | undefined;
  readonly entries: ReadonlyArray<{
    readonly node: {
      readonly __typename: "AuthorizedEvent";
      readonly " $fragmentSpreads": FragmentRefs<"VideoListEventData">;
    } | {
      readonly __typename: "Missing";
      readonly __typename: "Missing";
    } | {
      readonly __typename: "NotAllowed";
      readonly __typename: "NotAllowed";
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  }>;
  readonly hasPublicRssFeed: boolean;
  readonly id: string;
  readonly isBookmark: boolean;
  readonly title: string;
  readonly " $fragmentType": "PlaylistBlockPlaylistData";
} | {
  readonly __typename: "NotAllowed";
  readonly __typename: "NotAllowed";
  readonly " $fragmentType": "PlaylistBlockPlaylistData";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "PlaylistBlockPlaylistData";
};
export type PlaylistBlockPlaylistData$key = {
  readonly " $data"?: PlaylistBlockPlaylistData$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlaylistBlockPlaylistData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlaylistBlockPlaylistData",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creator",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canWrite",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPublicRssFeed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isBookmark",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PlaylistEntry",
          "kind": "LinkedField",
          "name": "entries",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "VideoListEventData",
                      "selections": [
                        (v1/*: any*/),
                        (v2/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "created",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "creators",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isLive",
                          "storageKey": null
                        },
                        (v3/*: any*/),
                        {
                          "condition": "includeSeries",
                          "kind": "Condition",
                          "passingValue": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Series",
                              "kind": "LinkedField",
                              "name": "series",
                              "plural": false,
                              "selections": [
                                (v2/*: any*/),
                                (v1/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ]
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "SyncedEventData",
                          "kind": "LinkedField",
                          "name": "syncedData",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "thumbnail",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "duration",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "startTime",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "endTime",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "audioOnly",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "includeSeries",
                          "value": true
                        }
                      ],
                      "argumentDefinitions": [
                        {
                          "defaultValue": false,
                          "kind": "LocalArgument",
                          "name": "includeSeries"
                        }
                      ]
                    }
                  ],
                  "type": "AuthorizedEvent",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "AuthorizedPlaylist",
      "abstractKey": null
    }
  ],
  "type": "Playlist",
  "abstractKey": "__isPlaylist"
};
})();

(node as any).hash = "9cdd7e406950c04160844cf04c6df0bf";

export default node;
